import React, { useState } from 'react';
import { motion } from 'framer-motion';

const models = [
    {
        id: 1,
        title: "Cloud Services",
        desc: "Elevate your applications with Mobikode cloud services designed to make things simpler, faster, and more secure. We help you move to the cloud smoothly, protect your data, improve performance, and reduce unnecessary costs so you can focus more on growing your business, not managing infrastructure.",
    },
    {
        id: 2,
        title: "Cloud Migration",
        desc: "The future is already here, and cloud is now a simple necessity for running smarter, more efficient, and profitable businesses. At Mobikode, we help you move to the cloud with ease, improving your core operations and setting you up for a more flexible, future-ready way of working.",
    },
    {
        id: 3,
        title: "DevOps Services",
        desc: "At Mobikode, we keep things simple and practical. We continuously improve your systems using real data, modern tools, and proven methods backed by consistent hard work to help your infrastructure perform better and deliver results you can actually see and rely on.",
    },
];

const CloudEngSection = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    return (
        <section className="bg-white overflow-hidden pt-[60px] lg:pt-[90px]">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <div className="mb-[35px] lg:mb-[45px]">
                    <h2 className="font-sora text-[20px] lg:text-[30px] font-[600] text-[#01386A] tracking-tight leading-[1.2] mb-3">
                        Explore Our Services
                    </h2>
                    <p className="text-[#49577A] lg:text-[16px] text-[14px] leading-[24px] font-[500] font-graphik max-w-[700px]">
                        At Mobikode, we help you build better products, scale faster, and turn ideas into impactful solutions with confidence.
                    </p>
                </div>

                <div className="relative w-full h-[380px] sm:h-[440px] lg:h-[480px] overflow-hidden bg-[#020D26] flex flex-col justify-end">

                    <img
                        src="/assets/services/bg3.png"
                        alt="Section Graphic"
                        className="absolute inset-0 w-full h-full object-cover object-center pointer-events-none opacity-80"
                    />

                    <div className="relative z-10 w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 items-end">
                        {models.map((model, index) => {
                            const isActive = activeIndex === index;

                            return (
                                <div
                                    key={model.id}
                                    onMouseEnter={() => setActiveIndex(index)}
                                    onClick={() => setActiveIndex(index)}
                                    className={`cursor-pointer transition-all duration-300 border-t lg:border-t-0 border-[#FFFFFF] lg:border-r last:border-r-0 ${isActive
                                            ? "bg-[#01386A] p-6 lg:p-7 min-h-[190px] lg:min-h-[220px] flex flex-col justify-between shadow-[0_-8px_25px_rgba(0,0,0,0.3)] z-20"
                                            : "bg-[#01386A] hover:bg-[#013260] p-5 lg:p-6 min-h-[75px] lg:min-h-[85px] flex items-center justify-start z-10"
                                        }`}
                                >
                                    <h3 className="font-sora text-white text-[16px] lg:text-[20px] font-[600] leading-[1.3]">
                                        {model.title}
                                    </h3>

                                    {isActive && model.desc && (
                                        <motion.p
                                            initial={{ opacity: 0, y: 10 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{ duration: 0.3 }}
                                            className="font-graphik text-white text-[14px] lg:text-[16px] font-[500] leading-[1.6] mt-4"
                                        >
                                            {model.desc}
                                        </motion.p>
                                    )}
                                </div>
                            );
                        })}
                    </div>

                </div>

            </div>
        </section>
    );
};

export default CloudEngSection;